/* eslint-disable no-nested-ternary */
import { css } from "@emotion/css";
import themeMui from "utility/ui/theme";

const styles = {
  input: ({ error, focused }) => css`
    padding: 12.5px 14px;
    border-radius: ${themeMui.shape.borderRadius}px;

    border: 1px solid
      ${error ? themeMui.palette.error.main : focused ? themeMui.palette.primary.main : themeMui.palette.grey[400]};

    transition: border-color 0.3s, box-shadow 0.3s;

    &:hover {
      border-color: ${error ? themeMui.palette.error.dark : themeMui.palette.primary.main};
    }

    cursor: pointer;
  `,
};

export default styles;
